import { createEnumParam } from "use-query-params";

export enum SortingDirection {
    Asc = 'asc',
    Desc = 'desc',
}

export const SortOrderEnumParam = createEnumParam([SortingDirection.Asc, SortingDirection.Desc])